import React, { useState } from "react";
import {
	// Checkbox,
	CheckboxList,
	RadioButtonList,
	Textarea,
} from "../../../../../components/core";
import { classNames } from "primereact/utils";
import { VirtualScroller } from "primereact/virtualscroller";
import TriggerAutoCompleteTextarea from "../../../../../components/core/trigger-auto-complete-textarea";
import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";

export default function TemplateItem({
	title = "TITLE",
	subtitle = "Subtitle",
	messageMedia = [
		{ id: 1, text: "Option 1", checked: false },
		{ id: 2, text: "Option 2", checked: false },
		{ id: 3, text: "Option 3", checked: false },
	],
	smsMessage,
	appMessage,
	variable = ["Hello", "World"],
	onChange,
	operatorMessageTypeId,
	disabled = false,
	checked,
	setChecked,
	setEditingDone,
	checkedStates,
}) {
	console.log({ variable: variable });
	const [value, setValue] = React.useState("");

	const itemTemplate = (item, options) => {
		return (
			<div
				className={"even:bg-stone-300 cursor-pointer hover:bg-stone-200"}
				style={{ height: options.props.itemSize + "px" }}
			>
				{item}
			</div>
		);
	};

	return (
		<div className="bg-stone-100 pb-2">
			<div className="bg-primary-primaryYellow py-2">
				<p className="text-xl text-black font-bold text-center">{title}</p>
				<p className="text-black font-bold text-center">{subtitle}</p>
				<div className="flex w-fit mx-auto">
					<p className="text-black font-bold text-center mt-3 mx-auto">
						Send alert via:
					</p>
					{/* <RadioButtonList
						className="mr-auto my-auto"
						dataItems={messageMedia}
						name={"messageMedia"}
						handleChange={(e) => console.log(e)}
					/> */}
					<CheckboxList
						disabled={disabled}
						className="mr-auto my-auto"
						dataItems={messageMedia}
						name={"messageMedia"}
						handleOnChange={(e) => {
							onChange(e, operatorMessageTypeId);
						}}
					/>
				</div>
			</div>

			<div className="grid grid-cols-3 gap-2 p-4">
				<div className="col-span-2 mx-4 mt-2">
					<div>
						<p className="font-bold">SMS Message</p>
						<TriggerAutoCompleteTextarea
							currentValue={smsMessage}
							onHandleChange={(e) => onChange(e, operatorMessageTypeId)}
							name={"messageViaSms"}
							variables={variable}
							maxLength={320}
							disabled={disabled}
						/>
					</div>

					{/* <Checkbox label="APP Message Same as SMS" /> */}
					<div className="flex align-items-center py-5">
						<Checkbox
							checked={checked}
							// checked={checkedStates?.[operatorMessageTypeId]}
							inputId="appMessageSame"
							onChange={(e) => {
								setChecked(e.checked);

								setEditingDone(true);
							}}
						/>
						<label htmlFor="appMessageSame" className="ml-2">
							APP Message Same as SMS
						</label>
					</div>

					<div>
						<p className="font-bold">APP Message</p>
						<TriggerAutoCompleteTextarea
							disabled={disabled}
							readOnly={checked ? true : false}
							currentValue={checked ? smsMessage : appMessage}
							onHandleChange={(e) => onChange(e, operatorMessageTypeId)}
							name={"messageViaApp"}
							variables={variable}
							maxLength={1000}
						/>
					</div>
				</div>
				<div className="mx-4 mt-2 h-full">
					<p className="font-bold">Variables:</p>
					<div
						className="card h-full "
						style={{
							width: "100%",
							height: "90%",
							backgroundColor: "white",
							padding: 2,
							overflowY: "auto",
						}}
					>
						{variable.map((data, key) => {
							return (
								<div className="py-4 even:bg-secondary-buttonGray">{data}</div>
							);
						})}
						{/* <VirtualScroller
							items={variable}
							itemSize={50}
							itemTemplate={itemTemplate}
							className="border-1 surface-border border-round"
							style={{
								width: "100%",
								height: "90%",
								backgroundColor: "white",
								padding: 2,
							}}
						/> */}
					</div>
				</div>
			</div>
		</div>
	);
}
